import React from 'react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { ChevronRight } from 'lucide-react';
import { ReportColumn } from './types';
import { ReportTableRow } from './ReportTableRow';

const DEFAULT_ITEMS_TO_SHOW = 5;

interface AccordionReportSectionProps {
  data: Record<string, any>[];
  columns: ReportColumn[];
  sectionTitle?: string;
  maxItems?: number;
  showViewAll?: boolean;
  onViewAll?: (sectionTitle?: string) => void;
  onRowClick?: (item: Record<string, any>) => void;
  className?: string;
}

const AccordionReportSection: React.FC<AccordionReportSectionProps> = ({
  data,
  columns,
  sectionTitle,
  maxItems = DEFAULT_ITEMS_TO_SHOW,
  showViewAll = true,
  onViewAll,
  onRowClick,
  className = '',
}) => {
  const visibleData = data.slice(0, maxItems);
  const hasMoreData = data.length > maxItems;

  const handleViewAll = () => {
    onViewAll?.(sectionTitle);
  };

  return (
    <div className={cn('px-6 pb-4', className)}>
      <div className="space-y-3">
        {visibleData.length > 0 ? (
          visibleData.map((item, index) => (
            <ReportTableRow
              key={item.id || index}
              item={item}
              columns={columns}
              onRowClick={onRowClick}
            />
          ))
        ) : (
          <p className="text-sm text-gray-500 text-center py-8">No data available for this section.</p>
        )}
      </div>

      {showViewAll && hasMoreData && (
        <div className="pt-4 mt-4 border-t border-gray-100">
          <Button
            variant="ghost"
            size="sm"
            className="w-full justify-center text-sm text-sky-600 hover:text-sky-700 hover:bg-sky-50"
            onClick={handleViewAll}
          >
            View all ({data.length}) <ChevronRight className="h-4 w-4 ml-1" />
          </Button>
        </div>
      )}
    </div>
  );
};

AccordionReportSection.displayName = 'AccordionReportSection';

export { AccordionReportSection };
